export enum ActionTypeEnum {
   URL_LINK = 'urlLink',
   ROUTER_LINK = 'routerLink'
}